import { handlePriceByComma } from '@/helpers/common';
import { validatePrice } from '@/utils/category';
import CurrencyIcon from '../../icons/currency-icon';
import { useLocale } from 'next-intl';

const ProductCardPrice = ({ price, isFromGrid }) => {
  const locale = useLocale();
  const isEnglish = locale === 'en';
  const prices = validatePrice(price);
  
  // Calculate derived values
  const finalPrice = prices?.final_price || prices?.originalPrice;
  const hasDiscount = prices?.final_price && prices?.final_price !== prices?.originalPrice;
  const savedAmount = prices?.originalPrice - prices?.final_price;
  const discountPercentage = +handlePriceByComma(prices?.discount);
  const hasSpecialPrice = !!prices?.specialPrice;

  // Text constants
  const saveText = isEnglish ? 'SAVE' : 'وفر';
  const offText = isEnglish ? 'Off' : 'خصم';

  // Component styles
  const priceContainerClass = `mt-2 flex items-center justify-between ${
    isFromGrid ? 'flex-col items-start max-sm:flex-row' : ''
  }`;

  const saveTagClass = `bg-primary mt-1.5 flex items-center justify-between rounded-lg px-2 py-1 text-xs text-white max-sm:text-[10px] ${
    hasDiscount ? '' : 'invisible'
  }`;

  const discountBadgeClass = `bg-primary absolute start-2.5 top-2.5 flex h-6 w-15 items-center justify-center rounded text-center text-xs text-white ${
    hasSpecialPrice ? 'visible' : 'invisible'
  }`;

  return (
    <>
      {/* Price Display */}
      <div className={priceContainerClass}>
        <span className='flex items-center gap-1 font-semibold max-md:text-[15px] max-sm:text-xs md:text-base lg:text-lg'>
          {handlePriceByComma(finalPrice)}
          <CurrencyIcon className='size-4 max-md:size-3 max-sm:size-2.75' />
        </span>
        
        {hasDiscount && (
          <span className='flex items-center gap-1 text-sm text-gray-400 line-through max-md:text-[15px] max-sm:text-xs'>
            {handlePriceByComma(prices.originalPrice)}
            <CurrencyIcon className='size-2.75' />
          </span>
        )}
      </div>

      {/* Savings Information */}
      {(discountPercentage > 0 || handlePriceByComma(savedAmount) > 0) &&
      <div className={saveTagClass}>
        <span className='flex items-center gap-1'>
          {saveText} {handlePriceByComma(savedAmount)}
          <CurrencyIcon className='size-3 max-sm:size-2.75' />
        </span>
        
        {discountPercentage > 0 && (
          <span>
            {handlePriceByComma(prices?.discount)}% {offText}
          </span>
        )}
      </div>
      }

      {/* Discount Badge */}
      {discountPercentage > 0 && 
        <span className={discountBadgeClass}>
          -{handlePriceByComma(prices?.discount)}%
        </span>
      }
    </>
  );
};

export default ProductCardPrice;